import { Ellipsis } from '@/components/ui/ellipsis';
import { FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { literatureReviewPaths } from '@/paths';
import { ColumnDef } from '@tanstack/react-table';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useNavigate } from 'react-router';
import { EditLiteratureReviewModal } from './EditLiteratureReviewModal';

dayjs.extend(relativeTime);

type LiteratureReview = {
  id: string;
  name: string;
  createdAt?: Date;
  updatedAt?: Date;
};

export const useLiteratureReviewsColumns =
  (): ColumnDef<LiteratureReview>[] => {
    return [
      {
        accessorKey: 'name',
        header: () => {
          return (
            <Text variant="body-sm" color="primary">
              Name
            </Text>
          );
        },
        cell: ({ row }) => {
          const navigate = useNavigate();
          const handleRowClick = () => {
            navigate(
              `${row.original.id}/${literatureReviewPaths.steps.search}`
            );
          };

          return (
            <FlexRow
              gap="2"
              alignItems="center"
              className="cursor-pointer hover:underline"
              onClick={handleRowClick}
            >
              <Ellipsis className="max-w-[50ch] w-full" asChild hasTooltip>
                <Text variant="body-sm" color="primary">
                  {row.original.name}
                </Text>
              </Ellipsis>
            </FlexRow>
          );
        },
      },
      {
        accessorKey: 'createdAt',
        header: () => {
          return (
            <Text variant="body-sm" color="primary">
              Created
            </Text>
          );
        },
        cell: ({ row }) => {
          const navigate = useNavigate();

          const handleRowClick = () => {
            navigate(
              `${row.original.id}/${literatureReviewPaths.steps.search}`
            );
          };

          const createdAt = row.original.createdAt;
          return (
            <FlexRow
              gap="2"
              alignItems="center"
              className="cursor-pointer hover:underline"
              onClick={handleRowClick}
            >
              <Text variant="body-sm" color="secondary">
                {createdAt ? dayjs(createdAt).fromNow() : '-'}
              </Text>
            </FlexRow>
          );
        },
      },
      {
        accessorKey: 'actions',
        meta: {
          headerClassName: 'w-10',
          cellClassName: 'w-10',
        },
        header: () => {
          return null;
        },
        cell: ({ row }) => {
          return (
            <EditLiteratureReviewModal literatureReviewId={row.original.id} />
          );
        },
      },
    ];
  };
